import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { SliderFilesListResource } from 'app/models/SliderFilesListResource';

@Component({
  selector: 'vbn-slider-list',
  templateUrl: './slider-list.component.html',
  styleUrls: ['./slider-list.component.scss']
})
export class SliderListComponent implements OnInit {
  userEmail: string;
  errorMessage: any;
  sliderList:SliderFilesListResource;
  constructor(
    private service: UtilsService,
    private router: Router,
    private _notificationService: NotificationsService,
    private translate: TranslateService,
    
  ) {
    this.sliderList= new SliderFilesListResource();
   }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getSlidersForUser();
  }

  getSlidersForUser(): void {
    this.service.get(`admin/slider/getList?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          this.sliderList=response;
        },
        error => this.errorMessage = <any>error);
  }

  delete(rid) {
    this.service.get(`admin/slider/delete?id=${rid}`)
      .subscribe(
        response => {
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Slider was deleted!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })

          this.getSlidersForUser();
        },
        error => this.errorMessage = <any>error);
  }
  edit(rid) {
    this.router.navigate(['/edit-slider/' + btoa('{ "sliderRid" : "' + rid + '"}')]);
  }

}
